module.exports = __webpack_public_path__ + "static/media/category14.b95b78ab.png";